import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BranchState {
  // null = "Todas las sucursales" (org-wide). Only administrators ever set a non-null value
  // (enforced by useBranchScope) — see docs/customer-portal.md sibling note in the Phase 6 plan.
  selected_branch_id: string | null;
  setSelectedBranch: (id: string | null) => void;
  clearSelectedBranch: () => void;
}

/**
 * Admin-only multi-branch oversight selection. Persisted per browser (like the workstation),
 * but consumption is gated through `useBranchScope()` (returns null for non-admins) and the
 * store is cleared on logout, so a non-admin can never emit a non-null branch_id.
 */
export const useBranchStore = create<BranchState>()(
  persist(
    (set) => ({
      selected_branch_id: null,
      setSelectedBranch: (id) => set({ selected_branch_id: id }),
      clearSelectedBranch: () => set({ selected_branch_id: null }),
    }),
    { name: 'novapet:branch' },
  ),
);
